export enum Mode {
  DEV = 8444,
  MAIN = 8443,
}
